import * as React from "react"

import { cn } from "@/lib/utils"

interface InputProps extends Omit<React.ComponentProps<"input">, "size"> {
  size?: "sm" | "default"
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, size = "default", ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        data-slot="input"
        className={cn(
          size === "sm" ? "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5 outline-none" : "h-9 w-full min-w-0 rounded-md bg-white px-3 py-1 text-base text-[lch(9.821_0_282.863)] transition-all outline-none",
          "border-[0.5px] border-[lch(83.025_0_282.863)]",
          "hover:border-[lch(60_0_282.863)]",
          "focus:border-[1px] focus:border-[oklch(0.52_0.21_284)]",
          "placeholder:text-[lch(38.893_1_282.863)]/60",
          "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
          size === "sm" ? "text-sm" : "text-base",
          "min-w-0",
          className
        )}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }

